import { createAction, props } from '@ngrx/store';
import { Sachverhalt, SachverhaltBearbeiten, SachverhaltErstellen } from '@models/dossier/dossier-models';
import { IServerValidationErrors } from 'app/core/services/validation/models/IServerValidationErrors';
import { DossierSachverhaltLoeschenBeantragen } from 'app/modules/dossier-area/ducks/models/dossierSachverhaltLoeschenBeantragen';
import { LoadSachverhalt } from 'app/modules/dossier-area/ducks/models/loadSachverhalt';

// Effect Actions
export const dossierBearbeitenSachverhaltAenderungenVerwerfen = createAction(
  '[Dossier - Effect] Dossier Bearbeiten Sachverhalt Aenderungen Verwerfen',
  props<{ payload: DossierSachverhaltLoeschenBeantragen }>()
);

export const dossierBearbeitenSachverhaltAenderungenVerwerfenError = createAction(
  '[Dossier - Effect] Dossier Bearbeiten Sachverhalt Aenderungen Verwerfen Error',
  props<{ payload: DossierSachverhaltLoeschenBeantragen }>()
);

export const dossierSachverhaltLoeschenBeantragen = createAction(
  '[Dossier - Effect] Dossier Sachverhalt Loeschen Beantragen',
  props<{ payload: DossierSachverhaltLoeschenBeantragen }>()
);

export const dossierSachverhaltLoeschenBeantragenError = createAction(
  '[Dossier - Effect] Dossier Sachverhalt Loeschen Beantragen Error'
);

export const dossierNeuenSachverhaltLoeschen = createAction(
  '[Dossier - Effect] Dossier Neuen Sachverhalt Loeschen',
  props<{ payload: DossierSachverhaltLoeschenBeantragen }>()
);

export const dossierNeuenSachverhaltLoeschenError = createAction(
  '[Dossier - Effect] Dossier Neuen Sachverhalt Loeschen'
);

export const createSachverhaltAndCloseSuccess = createAction(
  '[Dossier - Effect] Create Sachverhalt And Close Window Success'
);

export const openSelectMerkmalDialog = createAction(
  '[Dossier - Effect] Open select Merkmal Dialog for create sachverhalt',
  props<{ triggerElement?: HTMLElement }>()
);

export const openCreateSachverhaltDialog = createAction(
  '[Dossier - Effect] Open create Sachverhalt Dialog',
  props<{ triggerElement?: HTMLElement }>()
);

export const createSachverhaltAndOpen = createAction(
  '[Dossier - Effect] Create Sachverhalt And Open new Window',
  props<{ payload: SachverhaltErstellen }>()
);

export const createSachverhaltAndClose = createAction(
  '[Dossier - Effect] Create Sachverhalt And Close Window',
  props<{ payload: SachverhaltErstellen }>()
);

export const loadSachverhaltError = createAction(
  '[Dossier - Effect] Load Sachverhalt Error'
);

export const speichereSachverhaltInDossier = createAction(
  '[Dossier - Effect] Speichere Sachverhalt in Dossier',
  props<{ payload: SachverhaltBearbeiten }>()
);

export const bearbeiteNeuenSachverhaltInDossier = createAction(
  '[Dossier - Effect] Speichere neuen Sachverhalt in Dossier',
  props<{ payload: SachverhaltBearbeiten }>()
);

export const bearbeiteNeuenSachverhaltInDossierError = createAction(
  '[Dossier - Effect] Speichere neuen Sachverhalt in Dossier (Error)'
);

// Reducer Actions
export const loadSachverhaltEditSet = createAction(
  '[Dossier] Sachverhalt Edit Set',
  props<{ sachverhaltEdit: any }>()
);

export const startLoadingSachverhalt = createAction(
  '[Dossier] Start Loading Sachverhalt'
);

export const loadSachverhaltEffect = createAction(
  '[Dossier] Load Sachverhalt',
  props<{ param: LoadSachverhalt }>()
);

export const loadSachverhaltSuccess = createAction(
  '[Dossier] Load Sachverhalt Success',
  props<{ sachverhalt: Sachverhalt }>()
);

export const setServerValidationError = createAction(
  '[Sachverhalt] set server validation errors on saving sachverhalt',
  props<{ serverValidationErrors: IServerValidationErrors }>()
);

export const resetServerValidationError = createAction(
  '[Sachverhalt] reset server validation errors'
);

export const createSachverhalteSuccess = createAction(
  '[Sachverhalt] Create Sachverhalte Success'
);
